export const leaderboardKeys = {
    leaderboard: (subdomain, sprintId) => sprintId ? ['leaderboard', subdomain, sprintId] : ['leaderboard', subdomain],
    sprints: (subdomain, sprintId) => sprintId ? ['sprints', subdomain, sprintId] : ['sprints', subdomain],
    rank: (subdomain, userId, sprintId) => sprintId ? ['rank', subdomain, userId, sprintId] : ['rank', subdomain, userId],
    upcomingAndRecentSprints: () => ['upcomingAndRecentSprints'],
};
